import { useState } from "react";
// import profileimg from "../../Images/profileimg.png";
import "./Memberownprofile.css";
import { useParams } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import { useEffect } from "react";
import { useSelector } from "react-redux";
// import { Helmet } from "react-helmet-async";
import ProfileSkeletonNonMemUser from "../../Modal/skeleton/ProfileSkeletonNonMemUser";
import MemberProfile from "./components/MemberProfile";
import NonMemberProfile from "./components/NonMemberProfile";
import SeoProfileMetadata from "../BusinessPage/SeoProfileMetadata";

const MyProfile = () => {
    const params = useParams()
    const [isLoading, setIsLoading] = useState(true);
    const { UserProfileID } = useSelector((state) => state.app);
    const [data, setData] = useState();

    const getUserProfileByParam = async (id) => {
        const res = await HttpClient.requestData(`single-user-by-username/${id}`, "GET", {});
        if (res && res?.status) {
            setData(res?.data);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        params.name === "business-user" ? setData(UserProfileID) && setIsLoading(false) : getUserProfileByParam(params.name)
    }, [params.name]);

    return (
        <>
            <SeoProfileMetadata data={data} canonicalUrl={`${process.env.REACT_APP_APPLICATION_URL}/profile/${data?.userName}`} />
            {isLoading ? (
                <ProfileSkeletonNonMemUser />
            ) : (
                <>
                    {data && data?.memberStatus && (
                        <MemberProfile />
                    )}
                    {!data?.memberStatus && (
                        <NonMemberProfile />
                    )}
                </>
            )}
        </>
    );
};

export default MyProfile;
